import { gql } from "@apollo/client";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";

import QueryBrand from "./Brand.graphql";
import Brand from "../../domain/Brand";

export default function useBrand(id: string) {
    const query = useSuspenseQuery<{ brand: Brand }>(
        gql(QueryBrand),
        id
            ? {
                variables: {
                    id,
                },
            }
            : skipToken,
    );
    return id
        ? new Brand(query.data.brand)
        : undefined;
}
